import { api, apis } from 'api';
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import styles from './mark.module.scss';
import { useContactMarked } from '@web-common/hooks/useContactModel';
import { Tooltip } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { ContactActions, useActions } from '@web-common/state/createStore';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import { getIn18Text } from 'api';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
const dataTracker = api.requireLogicalApi(apis.dataTrackerApiImp);
const SiriusContactMark = props => {
    const { size = 16, onMarked, contactId, email, orgId, canOperate, style, visibleToolTip, cancelToast, visibleHover, noMarkedHidden, defaultMarked, useId, className, useText, useCardIcon, testId, } = props;
    const { productVersionInfo: { navigateVersion }, } = useGetProductAuth();
    const contactAction = useActions(ContactActions);
    const marked = useContactMarked({ email, orgId, contactId, useId });
    const [checked, setChecked] = useState(defaultMarked ? true : marked);
    const [openTooltip, setOpenTooltip] = useState(false);
    useEffect(() => {
        setChecked(marked);
    }, [marked]);
    const handleOperate = async (isMarked, id) => {
        if (!cancelToast || isMarked) {
            setChecked(isMarked);
        }
        const data = {
            id,
            type: orgId ? 2 : 1,
        };
        const action = isMarked ? 'add' : 'cancel';
        const { success, msg } = await contactApi.doBatchOperatePersonalMark([data], action);
        if (success) {
            setChecked(isMarked);
            onMarked && onMarked(isMarked);
            if (orgId) {
                const m = new Map();
                m.set(orgId, isMarked);
                contactAction.doUpdateOrgMarkedMap(m);
            }
            else if (email && contactId) {
                contactAction.doUpdateEmailMarkedMap({ type: action, isAll: false, data: new Map(Object.entries({ [email]: [contactId] })) });
            }
            message.success(isMarked ? getIn18Text('addMarkSuccess') : getIn18Text('cancelMarkSuccess'));
        }
        else {
            setChecked(!isMarked);
            message.error(msg || getIn18Text(isMarked ? 'addMarkFail' : 'cancelMarkFail'));
        }
    };
    const handleClick = async (e) => {
        if (!canOperate) {
            return;
        }
        const id = orgId || contactId;
        if (!id) {
            return;
        }
        e.stopPropagation();
        const isMarked = !checked;
        if (!isMarked && cancelToast) {
            SiriusModal.error({
                title: getIn18Text('cancelToastTitle'),
                content: getIn18Text('cancelToastContent'),
                onOk: async () => {
                    dataTracker.track('pcMail_click_button_cancelStarContactPage', { buttonName: '确定' });
                    await handleOperate(isMarked, id);
                },
                onCancel: () => {
                    dataTracker.track('pcMail_click_button_cancelStarContactPage', { buttonName: '取消' });
                },
            });
        }
        else {
            handleOperate(isMarked, id);
        }
    };
    const tooltipTitle = typeof visibleToolTip === 'string' ? visibleToolTip : getIn18Text(checked ? 'cancelMark' : 'addMark');
    if (process.env.BUILD_ISEDM || navigateVersion) {
        return null;
    }
    return noMarkedHidden && !checked ? null : (React.createElement(Tooltip, { title: tooltipTitle, placement: "top", visible: openTooltip, onVisibleChange: open => {
            setOpenTooltip(open && !!visibleToolTip);
        } },
        React.createElement("div", { "data-test-id": testId, "data-test-checked": checked, onClick: handleClick, className: classnames(className || styles.siriusContactMarkContainer, visibleHover && styles.markHover), style: style }, useText ? (React.createElement("span", null, tooltipTitle)) : (React.createElement("div", { style: { width: size, height: size }, className: classnames(styles.markIcon, {
                [styles.checked]: checked,
                [styles.group]: !!orgId,
                [styles.detailIcon]: useCardIcon,
            }) })))));
};
export default SiriusContactMark;
